import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: #DEDEDE;
  padding: 40px 0 0;
  height: 134px;
  a {
    display: flex;
    height: 100%;
    width: 100%;
    .item {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    } 
  }
`;

const Inbound = ({banner, link}) => {
  return (
    <Container>
      <div className="wrapper flex">
        <a href={ link && link.url } rel="noopener noreferrer" target="_blank">
          <div className="item" style={ { backgroundImage: `url(${banner && banner.url})`}}></div>
        </a>
      </div>
    </Container>
  );
}

export default Inbound;
